<template>
  <v-dialog v-model="showModal" min-width="500px" width="500px" max-width="700px" persistent>
    <v-card flat>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>Zlecanie zabiegu</v-toolbar-title>
      </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-select :items="filteredzabiegi"  item-text="nazwa"
                          label="Zabieg" placeholder="Wybierz zabieg..."
                          v-model="wybrany_zabieg"
                          return-object
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="wybrany_zabieg && wybrany_zabieg.podtypy && wybrany_zabieg.podtypy.length >0">
              <v-col cols="12">
                <v-select :items="filteredpodtypy"  item-text="nazwa"
                          label="Podtyp zabiegu" placeholder="Wybierz podtyp..."
                          v-model="wybrany_podtyp"
                          return-object
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="wybrany_zabieg">
              <v-col cols="12">
                <v-text-field
                    v-model.number="dlugosc"
                    hide-details
                    single-line
                    type="number"
                />
              </v-col>
            </v-row>
            <v-row v-if="wybrany_zabieg">
              <v-col cols="12">
                <v-text-field placeholder="Kliknij aby wybrać termin..." @click="showWybierzTermin()" :value="termin"></v-text-field>
              </v-col>
            </v-row>

          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="zlec()">Zleć</v-btn>
        </v-card-actions>
    </v-card>
    <DostepneGodzinyPicker :visible="wybierzTermin" :godziny="terminy" @close="wybierzTermin = false" @selected="selectedEvent" ></DostepneGodzinyPicker>
  </v-dialog>
</template>

<script>
import {visitService} from "@/services";
import swal from "sweetalert";
import DostepneGodzinyPicker from "@/components/visits/DostepneGodzinyPicker";
import dayjs from "dayjs";

export default {
  name: "ZlecZabieg",
  components: {DostepneGodzinyPicker},
  props: ["zabiegi","visible", "data_wizyty","vid"],
  data() {
    return {
      wybrany_zabieg: null,
      wybrany_podtyp: null,
      dlugosc: 0,
      terminy: null,
      wybierzTermin: false,
      termin: '',
      wybranyTermin: null
    }
  },
  mounted() {

  },
  methods: {
    selectedEvent(item)
    {
      this.wybranyTermin = item
      this.termin = dayjs(item.data_start).format("HH:mm")+" - "+dayjs(item.data_koniec).format("HH:mm")
      this.wybierzTermin = false
    },
    zlec()
    {
      if(this.wybranyTermin == null)
      {
        this.showError(false,'Proszę wybrać termin')
        return
      }
      this.$emit('selected',{
        zabieg: this.wybrany_zabieg,
        podtyp_zabiegu: this.wybrany_podtyp,
        termin: this.wybranyTermin
      })
    },
    showWybierzTermin()
    {
      visitService.getWolneTerminyZabiegu({
        Date: dayjs(this.data_wizyty).format("YYYY-MM-DD HH:mm"),
        ZabiegId: this.wybrany_zabieg.id,
        DlugoscZabiegu: this.dlugosc,
        CurrentVisitId: this.vid
      }).then(result => {
        this.terminy = result.data.result
        this.wybierzTermin = true
      }).catch(() => {
          this.showError(false,'Bład pobierania wolnych terminów.')
          return
      })
    },
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    }
  },
  computed: {
    showModal: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    filteredzabiegi: function() {
      return this.zabiegi.map(obj=> ({ ...obj, disabled: !obj.aktywny }))
    },
    filteredpodtypy: function() {
      if(this.wybrany_zabieg.podtypy == null)
      {
        this.wybrany_podtyp = null
        return []
      }
      return this.wybrany_zabieg.podtypy.map(obj=> ({ ...obj, disabled: !obj.aktywny }))
    }
  },
  watch: {
    wybrany_zabieg: function(v) {
      if(v!= null)
      {
        this.dlugosc = v.dlugoscWizyty
      }
    },
    wybrany_podtyp: function(v) {
      if(v!=null && v.dlugoscWizyty && v.dlugoscWizyty > 0)
      {
        this.dlugosc = v.dlugoscWizyty
      }
    }
  }
}
</script>

<style scoped>

</style>